import axios from 'axios';
import { ENVIRONMENT, TAVUS_BASEURL } from 'shared/model';

import { userStore } from 'entities/user';

export const tavusHttpService = axios.create({
  baseURL: TAVUS_BASEURL,
  timeout: 60000
});

tavusHttpService.interceptors.request.use(
  (config) => {
    if (!config.headers.Authorization) {
      config.headers.Authorization = userStore.getState().user?.internalKey;
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);
